export default "__VITE_ASSET__CyLrwwE0__"